import { PropsWithChildren } from 'react';

import { useStudioFocusModality } from './useStudioFocusModality';

// The rotating conic-gradient reads `--asm-glow-angle` and the `asm-glow-rot`
// keyframes, both defined in styles/main.css (@property / @keyframes can't be
// expressed as Tailwind utilities).
export const StudioPageFrame = ({ children }: PropsWithChildren) => {
  useStudioFocusModality();

  return (
    <div className="fixed inset-0 overflow-hidden p-[18px] font-studio animate-[asm-glow-rot_9s_linear_infinite] bg-[image:conic-gradient(from_var(--asm-glow-angle),theme(colors.studio.green),theme(colors.studio.lavender),theme(colors.studio.periwinkle),theme(colors.studio.sage),theme(colors.studio.green),theme(colors.studio.lavender),theme(colors.studio.green))]">
      <div className="flex h-full min-h-0 w-full items-center justify-center overflow-y-auto rounded-2xl bg-white">
        <div className="flex w-[446px] max-w-[calc(100%-40px)] flex-col items-center py-10">
          {children}
        </div>
      </div>
    </div>
  );
};
